import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetNotify } from 'slices/notifySlice';
import error from '../../assets/error-request.svg';
import invoice from '../../assets/invoice.svg';

const ErrorContainerNotify = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { detail } = useSelector((state) => state.detail);
  const tryAgain = () => {
    navigate(-2);
    dispatch(resetNotify());
  };

  const scrollEvent = () => {
    document.addEventListener('scroll', () => {
      const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
      if (element !== undefined) {
        if (window.scrollY <= 110) {
          element.classList.remove('active');
        } else {
          element.classList.add('active');
        }
      }
    });
  };

  useEffect(() => {
    scrollEvent();
  }, []);

  return (
    <Container className="bg-white">
      <div className="bg-alabaster pt-5 p-sm-3 pb-30 d-block d-sm-none sticky-resumen-mobile">
        <div className="wrap">
          <button
            type="button"
            className="header d-flex justify-content-between btn-link text-left">
            <div className="title opacity-70 ml-2">
              <img src={invoice} alt="invoice-img" />
              <h4 className="mt-15 text-tangaroa">Confirmación</h4>
            </div>
            <div className="icon-title font-weight-bold text-tangaroa">
              <i className="fas fa-plus" />
            </div>
          </button>
        </div>
      </div>

      <Row className="pb-60 py-sm-60">
        <Col lg={9} className="text-center text-tangaroa">
          <h2 className="mb-15 text-tangaroa">¡Lo sentimos!</h2>
          <h3>Ha ocurrido un error al momento de procesar tu solicitud.</h3>
          <h3 className="mb-45">Estamos trabajando en ello para resolverlo.</h3>
          <img src={error} alt="error-img" />
          <h4 className="mb-30 text-tangaroa f-600">Haz clic en el botón para intentarlo de nuevo.</h4>
          <button type="button" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor" onClick={tryAgain}>
            Reintentar
          </button>
        </Col>
        <Col lg={3} className="opacity-70">
          <div className="bg-alabaster p-3 br-1 d-none d-sm-block">
            <img src={invoice} alt="invoice-img" />
            <h4 className="mt-15 text-tangaroa">Confirmación</h4>
            <Row className="text-dark-blue ft-12">
              <Col lg={10} className="text-tangaroa">
                Puntos ofertados
              </Col>
              <Col lg={2} className="text-tangaroa">
                0
              </Col>
            </Row>
            <h4 className="mt-15 text-tangaroa">Tu Subasta Rewards</h4>
            <h5 className="text-tangaroa">{detail.title}</h5>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorContainerNotify;
